export class SurveyImportElementsAndUnitsNotFoundError extends Error {
    constructor(
        public sheet: 'surveys' | 'elements' | 'units',
        public elements: { objectCode: string; elementName: string; elementCode: string }[],
        public units: { objectCode: string; elementName: string; elementCode: string; unitName: string; unitCode: string }[],
        public objectsWithComposition: { id: string; code: string }[],
    ) {
        super('Elements/units not found');
        this.name = 'SurveyImportElementsNotFoundError';
    }
}
